// setInterval that keeps its pace while the tab is hidden. Chrome slows a hidden tab's own timers
// to once a second, which made Auto-Pace hear the microphone only once a second while the user
// worked in another app. A worker's timer is not slowed, so it sends the beat instead.
export interface SteadyInterval { stop: () => void }

export function steadyInterval(fn: () => void, ms: number): SteadyInterval {
    try {
        const src = `let h=null;onmessage=e=>{clearInterval(h);if(e.data>0)h=setInterval(()=>postMessage(0),e.data);};`;
        const url = URL.createObjectURL(new Blob([src], { type: 'text/javascript' }));
        const worker = new Worker(url);
        URL.revokeObjectURL(url);
        worker.onmessage = () => fn();
        worker.postMessage(ms);
        return { stop: () => { worker.postMessage(0); worker.terminate(); } };
    } catch {
        const h = setInterval(fn, ms);
        return { stop: () => clearInterval(h) };
    }
}
